module.exports = __webpack_public_path__ + "static/media/golden_ticket.43658970.jpg";